<template>
	<div>
		<el-card shadow="never">
			<p align="justify">
				No se encontró la página
			</p>
		</el-card>

	</div>
</template>

<script>
	import ElMain from "element-ui/packages/main/src/main";
	import ElCard from "element-ui/packages/card/src/main";

	export default {
		components: {
			ElCard,
			ElMain}

	}
</script>

<style scoped>

</style>